import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { AlertCircle, Clock, XCircle } from 'lucide-react';

export function StatusBanner({ status }) {
  if (status === 'draft' || !status) {
    return (
      <div className="card-surface p-6 mb-6 border-l-4 border-l-[#D4AF37] bg-amber-50" data-testid="draft-banner">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-6 w-6 text-[#D4AF37] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-heading text-lg font-medium text-[#1A1A1A]">Complete Your Profile</h2>
              <p className="text-sm text-stone-500 mt-0.5">
                Your provider profile is incomplete. Complete and submit it to get approved and start accepting bookings.
              </p>
            </div>
          </div>
          <Link to="/provider/onboarding">
            <Button className="btn-primary whitespace-nowrap" data-testid="complete-profile-btn">Continue Setup</Button>
          </Link>
        </div>
      </div>
    );
  }

  if (status === 'pending') {
    return (
      <div className="card-surface p-6 mb-6 border-l-4 border-l-blue-500 bg-blue-50" data-testid="pending-banner">
        <div className="flex items-start gap-3">
          <Clock className="h-6 w-6 text-blue-500 flex-shrink-0 mt-0.5" />
          <div>
            <h2 className="font-heading text-lg font-medium text-[#1A1A1A]">Awaiting Approval</h2>
            <p className="text-sm text-stone-500 mt-0.5">
              Your profile has been submitted and is under review. We'll notify you once it's approved. This usually takes 1-2 business days.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'rejected') {
    return (
      <div className="card-surface p-6 mb-6 border-l-4 border-l-red-500 bg-red-50" data-testid="rejected-banner">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <XCircle className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-heading text-lg font-medium text-[#1A1A1A]">Profile Update Required</h2>
              <p className="text-sm text-stone-500 mt-0.5">
                Your profile needs some updates before it can be approved. Please review and update your information.
              </p>
            </div>
          </div>
          <Link to="/provider/onboarding">
            <Button className="btn-primary whitespace-nowrap">Update Profile</Button>
          </Link>
        </div>
      </div>
    );
  }

  return null;
}
